import Vue from 'vue';

class Translations {
  GetTranslation(term: string): string {
    if (Vue.prototype.$l === 'sv') {
      return term;
    }
    if (Vue.prototype.$l === 'en') {
      switch (term) {
        case '1. Förutsättningar': return '1. Conditions';
        case '2. Analys': return '2. Analysis';
        case '3. Summering': return '3. Summary';
        case '4. Nästa steg': return '4. Next step';
        case ' av 100': return ' of 100';
        case ' av 400': return ' of 400';
        case 'Agenda': return 'Agenda';
        case 'Affärsmodell': return 'Business model';
        case 'Alla bolag borde': return 'All companies should';
        case 'Analys': return 'Analysis';
        case 'Andel: ': return 'Proportion: ';
        case 'Andel av nettoomsättningen': return 'Proportion of net sales';
        case 'Andra kostnader': return 'Other costs';
        case 'Anläggnings-tillgångar': return 'Fixed assets';
        case 'Anläggningstillgångar': return 'Fixed assets';
        case 'Av- och ned-skrivningar': return 'Depreciations and write-downs';
        case 'Av- och nedskrivningar': return 'Depreciations and write-downs';
        case 'Avkastning': return 'Yield';
        case 'Avslutning': return 'More';
        case 'Avsluta presentation': return 'End presentation';
        case 'Avsättningar': return 'Provisions';
        case 'Balans': return 'Balance sheet';
        case 'Balans-omslutning': return 'Total assets';
        case 'Balansdiagram': return 'Balance chart';
        case 'Balansdiagram, senaste': return 'Balance chart';
        case 'Balansomslutning': return 'Total assets';
        case 'Balansomslutning, flerår': return 'Total assets';
        case 'Balansräkning': return 'Balance sheet';
        case 'Begränsad': return 'Modest';
        case 'Betydande': return 'Major';
        case 'Bokslut': return 'Financial statement';
        case 'Bokslut ': return 'Date';
        case 'Boksluts-disp.': return 'Appropriations';
        case 'Bokslutsdispositioner': return 'Appropriations';
        case 'Bokslutsmöte': return 'Year-end meeting';
        case 'Bolag': return 'Companies';
        case 'Bolagskompass': return 'Business Navigator';
        case 'Bolagskompassen till vänster är dynamisk och genom att klicka på nyckeltalspunkterna i diagrammet visas ett mer detaljerat nyckeltalsdiagram.': return 'The business navigator on the left is dynamic and by clicking on the key figure points in the diagram a more detailed key figure diagram is displayed.';
        case 'Branschjämförelse': return 'Industry comparison';
        case 'Branschkompass': return 'Business Navigator';
        case 'Branschkompassen till vänster är dynamisk och genom att klicka på nyckeltalspunkterna i diagrammet visas ett mer detaljerat nyckeltalsdiagram.': return 'The business navigator on the left is dynamic and by clicking on the key figure points in the diagram a more detailed key figure diagram is displayed.';
        case 'Branschmedian': return 'Industry median';
        case 'Bruttoresultat': return 'Gross profit';
        case 'Covid-19': return 'Covid-19';
        case 'Definition': return 'Definition';
        case 'Din resa': return 'Six box model';
        case 'Direkt metod': return 'Direct method';
        case 'Drifts-kostnader': return 'Operating costs';
        case 'Driftsresultat': return 'Operating result';
        case 'Eget kapital': return 'Equity';
        case 'Eget kapital och skulder': return 'Total equity and liabilities';
        case 'Energi': return 'Energy costs';
        case 'Exempel': return 'Example';
        case 'Fastighetskostnader': return 'Property costs';
        case 'Feedback': return 'Feedback';
        case 'Finansiell styrka': return 'Financial strength';
        case 'Finansiella': return 'Financial';
        case 'Finansiella anläggningstillgångar': return 'Financial assets';
        case 'Finansiella intäkter': return 'Financial incomes';
        case 'Finansiella kostnader': return 'Financial costs';
        case 'Finansiella poster': return 'Financial posts';
        case 'Finansiering': return 'Financing';
        case 'Flerår': return 'Latest years';
        case 'Flerårsbalans': return 'Balance chart';
        case 'Flerårskompass': return 'Business Navigator';
        case 'Flerårsresultat': return 'Year-end meeting';
        case 'Flexibel presentation': return 'Flexible presentation';
        case 'Fokus': return 'Focus';
        case 'Fokusområde': return 'Focus';
        case 'Foton från unsplash.com': return 'Photos from unsplash.com';
        case 'Frakter & transport': return 'Freight and transportation';
        case 'Framtidsmöte': return 'Future meeting';
        case 'Framtidsplaner': return 'Future plans';
        case 'Framtids-utsikter': return 'Long term outlook';
        case 'Framtidsutsikter': return 'Long term outlook';
        case 'Fria kassaflöden': return 'Free cashflows';
        case 'Frågor': return 'Questions';
        case 'Följa betalningsströmmar': return 'Follow the payments';
        case 'Förbrukningsmaterial': return 'Consumable equipment and supplies';
        case 'Företag': return 'Company';
        case 'Försäkringar & riskhantering': return 'Insurance and other risk-related costs';
        case 'Förutsättningar': return 'Conditions';
        case 'Förvaltning': return 'Costs of administration';
        case 'Förväntningar': return 'Expectations';
        case 'Förändring rörelsekapital': return 'Change working capital';
        case ' ggr': return ' times';
        case 'Handlingsplan': return 'Action plan';
        case 'Har styrelse och ledning rätt hållbarhetskompetens?': return 'Do the board and management have the right sustainability competence?';
        case 'Helårsprognos': return 'Full-year forecast';
        case 'Historik': return 'History';
        case 'Hur skall ni åstadkomma det?': return 'How are you going to accomplish that?';
        case 'Hyra av anläggningstillgångar': return 'Hired fixed assets';
        case 'Hållbarhet': return 'Sustainability';
        case 'Hållbarhetskompass': return 'Sustainability Navigator';
        case 'Höga krav på hållbart perspektiv': return 'High demands on a sustainable perspective';
        case 'IB': return 'OB';
        case 'IB Kassa & Bank': return 'OB Cash & bank';
        case 'Immateriella': return 'Untangible';
        case 'Immateriella anläggningstillgångar': return 'Untangible assets';
        case 'Implementering': return 'Implementation';
        case 'In- och utbetalningar': return 'Deposits and withdrawals';
        case 'Index': return 'Index';
        case 'Indexerade nyckeltal': return 'Indexed key ratios';
        case 'Indirekt metod': return 'Indirect method';
        case 'Information': return 'Information';
        case 'Inför bokslut': return 'Pre year-end meeting';
        case 'Inhyrd personal': return 'Temporary employees';
        case 'Intäkter': return 'Income';
        case 'Investeringar': return 'Investments';
        case 'Justera för ej likviditetspåverkan': return 'Disclosure of non-cash activities';
        case 'Justerat eget kapital (eget kapital + beskattad del av obeskattade reserver) i procent av balansomslutningen. Nyckeltalet visar på bolagets finansiella stabilitet och långsiktiga överlevnadsförmåga.': return 'Adjusted equity (equity + taxed part of untaxed reserves) as a percentage of total assets. The key figure shows the companys financial stability and long-term viability.';
        case 'Justering för Av- och nedskrivningar': return 'Disclosure of depreciations and write-downs';
        case 'Justering för ej likviditetspåverkande poster': return 'Disclosure of non-cash activities';
        case 'Justering för Finansiella poster': return 'Disclosure of Financial posts';
        case 'Jämförbarhet över tid': return 'Comparability over time';
        case 'Kassa och bank': return 'Cash and bank';
        case 'Kassa & Bank': return 'Cash and bank';
        case 'Kassaflöde från den löpande verksamheten': return 'Cash from operating activities';
        case 'Kassaflöde från den operativa verksamheten': return 'Operating cash flow';
        case 'Kassaflöde från finansiering': return 'Cash flow from financing activities';
        case 'Kassaflöde från förändring av rörelsekapital': return 'Cash flow from change in working capital';
        case 'Kassaflöde från investeringar': return 'Cash flow from investing activities';
        case 'Kassaflöde från löpande verksamhet': return 'Cash flow from operating activities';
        case 'Kassaflöden': return 'Cash flows';
        case 'Kassaflödesanalys': return 'Cash flow analysis';
        case 'Kassalikviditet': return 'Quick ratio';
        case 'Kategorisering': return 'Categorization';
        case 'Kommentar': return 'Comment';
        case 'Kompetens': return 'Competence';
        case 'Konkurrent:': return 'Competitor:';
        case 'Konkurrentjämförelse': return 'Competitor comparison';
        case 'Konkurrentkompass': return 'Business Navigator';
        case 'Konsultintryck': return 'Our impressions';
        case 'Kontaktuppgifter': return 'Contact info';
        case 'Kontorsmaterial': return 'Office supplies';
        case 'Kortfristiga placeringar': return 'Short investments';
        case 'Kortfristiga skulder': return 'Short term debts';
        case 'Kortsiktig beredskap': return 'Short term preparation';
        case 'Kostnader för varor & material': return 'Goods and materials';
        case 'Kostnader för varor och material': return 'Goods and materials';
        case 'Kunder & Konsumenter': return 'Customers and Consumers';
        case 'Kunderna vill ha miljövänliga, etiska och hållbara produkter': return 'Customers want environmentally friendly, ethical and sustainable products';
        case 'Kundfordringar': return 'Accounts receivable';
        case 'Kundmöte': return 'Our services';
        case 'Kvartil': return 'Quartile';
        case 'Känner era intressenter till hur ni arbetar med hållbarhet?': return 'Do your stakeholders know how you work with sustainability?';
        case 'Känner ni till era kunders, finansiärers och medarbetares förväntningar?': return 'Do you know the expectations of your customers, financiers and employees?';
        case 'Känner ni till hur er affär påverkar samhället och miljön?': return 'Do you know how your business affects society and the environment?';
        case 'Lagstiftning': return 'Legislation';
        case 'Lokaler': return 'Rented premises';
        case 'Lokalsamhälle': return 'Local community';
        case 'Långfristiga skulder': return 'Long term debts';
        case 'Materiella': return 'Tangible';
        case 'Materiella anläggningstillgångar': return 'Tangible assets';
        case 'Medarbetare': return 'Wages and Personnel costs';
        case 'Medarbetarna': return 'Coworkers';
        case 'Media': return 'Media';
        case 'Median': return 'Median';
        case 'Metodik': return 'Method';
        case 'Metod': return 'Method';
        case 'Minskning(-)/Ökning(+) av Leverantörsskulder': return 'Decrease(-)/Increase(+) Accounts payable';
        case 'Minskning(-)/Ökning(+) av Räntebärande skulder': return 'Decrease(-)/Increase(+) Interest-bearing liabilities';
        case 'Minskning(-)/Ökning(+) av Övriga kortfristiga skulder': return 'Decrease(-)/Increase(+) Other short term debts';
        case 'mån': return 'mth';
        case 'Mål & nyckeltal': return 'Goals and key figures';
        case 'Mötesdatum': return 'Meeting date';
        case 'Mötesdeltagare': return 'Meeting participants';
        case 'Mötesinfo': return 'Meeting info';
        case 'Negativt eget kapital': return 'Negative equity';
        case 'Nettoomsättning': return 'Net sales';
        case 'Nettoomsättning, flerår': return 'Net sales';
        case 'Noteringar': return 'Notes';
        case 'Noteringar från bokslutsarbetet': return 'Notes';
        case 'Noteringar från revisionen': return 'Notes from the audit';
        case 'Nuläge': return 'Present state';
        case 'Nyckeltal': return 'Key ratio';
        case 'Nästa möte': return 'Next meeting';
        case 'Nästa steg': return 'Next step';
        case 'Obeskattade reserver': return 'Untaxed reserves';
        case 'Ohållbara företag får allt svårare att rekrytera och behålla personal': return 'Unsustainable companies are finding it increasingly difficult to recruit and retain staff';
        case 'Omsättningstillgångar': return 'Current assets';
        case 'Omsättningstillgångar exklusive lager och pågående arbete i procent av kortfristiga skulder. Nyckeltalet visar på bolagets betalningsförmåga på kort sikt.': return 'Current assets excluding inventories and work in progress as a percentage of current liabilities. The key figure shows the companys ability to pay in the short term.';
        case 'Omsättningstillgångar minskat med kortfristiga skulder i procent av nettoomsättningen. Nyckeltalet används bl.a. för att uppskatta bolagets kapitalbehov vid en expansion.': return 'Current assets reduced by current liabilities as a percentage of net sales. The key figure is used i.a. to estimate the companys capital needs in the event of an expansion.';
        case 'Omsättningstillväxt': return 'Growth in turn-over';
        case 'Omvärld & intressenter': return 'Stakeholders';
        case 'Operativ verksamhet': return 'Operations';
        case 'Operativa kassaflöden': return 'Operating cash flow';
        case 'Operativt kassaflöde': return 'Operating cash flow';
        case 'Optimera likviditeten': return 'Optimize liquidity';
        case 'Ordning & reda': return 'Discipline';
        case 'Paketerad tjänst': return 'Packaged service';
        case 'Pensioner': return 'Pensions';
        case 'Personalkostnader': return 'Cost of staff';
        case 'Procentuell förändring (justerad till tolvmånadersperiod) mellan föregående och innevarande års nettoomsättning. Nyckeltalet visar hur mycket företaget ökar eller minskar sin försäljning.': return 'Percentage change (adjusted to twelve-month period) between previous and current years net sales. The key figure shows how much the company increases or decreases its sales.';
        case 'Påtaglig': return 'Minor';
        case 'Påverkan': return 'Impact';
        case 'Reklam & PR': return 'Advertising and PR';
        case 'Reparation & underhåll': return 'Repairs and maintenance';
        case 'Resor': return 'Travel expenses';
        case 'Resultat': return 'Result';
        case 'Resultat efter finansiella intäkter och kostnader i procent av justerat eget kapital (eget kapital + beskattade del av obeskattade reserver). Nyckeltalet visar bolagets avkastning på ägarnas insatta kapital.': return 'Profit after financial income and expenses as a percentage of adjusted equity (equity + taxed part of untaxed reserves). The key figure shows the companys return on the owners invested capital.';
        case 'Resultat efter finansiella poster': return 'Result after financial investments';
        case 'Resultat före skatt': return 'Result before tax';
        case 'Resultatdiagram': return 'Income chart';
        case 'Resultatdiagram, senaste': return 'Income chart';
        case 'Resultaträkning': return 'Income statement';
        case 'Riskbuffert': return 'Risk buffer';
        case 'Räntabilitet på eget kapital': return 'Return on equity';
        case 'Räntetäckningsgrad': return 'Interest coverage';
        case 'Rörelsekapital': return 'Working capital';
        case 'Rörelsekapital i % av omsättning': return 'Working capital as % of net sales';
        case 'Rörelsekapital i % av nettoomsättningen': return 'Working capital as % of net sales';
        case 'Rörelsekostnader': return 'Operating costs';
        case 'Rörelsemarginal': return 'EBIT-margin';
        case 'Rörelseresultat': return 'Earnings Before Interest and Tax';
        case 'Rörelseresultat efter avskrivningar i procent av nettoomsättningen. Nyckeltalet anger hur stor andel i procent av varje försäljningskrona som blir kvar för att täcka räntor, skatt samt skapa vinst.': return 'Operating profit after depreciation as a percentage of net sales. The key figure indicates the percentage of each sales krona that remains to cover interest, tax and create profit.';
        case 'Rörelseresultat efter avskrivningar plus finansiella intäkter som multipel av finansiella kostnader. Nyckeltalet anger vilken förmåga bolaget har att täcka sina räntekostnader.': return 'Operating profit after depreciation plus financial income as a multiple of financial expenses. The key figure indicates the ability of the company to cover its interest expenses.';
        case 'Sammanfattning': return 'Summary';
        case 'Schablonmässig kategorisering': return 'Standard categorization';
        case 'Senaste bokslutet': return 'Latest year';
        case 'Senaste året': return 'Latest year';
        case 'Signering': return 'Signing';
        case 'SIE-import': return 'SIE-import';
        case 'Skapad via analyscenter.se': return 'Created with analyscenter.se';
        case 'Skatt': return 'Tax';
        case 'Skatter': return 'Taxes';
        case 'Skatt på årets resultat': return 'Tax';
        case 'Skillnaden i likvida medel': return 'Difference in cash and bank';
        case 'Skillnaden i procent mellan avkastning på totalt kapital och genomsnittlig skuldränta. Nyckeltalet visar med hur mycket bolagets totala avkastning överstiger de räntekostnader de betalar.': return 'The difference in percentage between return on total capital and average debt interest. The key figure shows how much the companys total return exceeds the interest costs they pay.';
        case 'Skulder': return 'Debt';
        case 'Soliditet': return 'Solidity';
        case 'Stora bolag måste': return 'Large companies must';
        case 'Stora förväntningar på etiskt, socialt och miljömässigt hållbart agerande': return 'High expectations for ethically, socially and environmentally sustainable action';
        case 'Storleksoberoende': return 'Size independent';
        case 'Stämma av nettoförändringen': return 'Check the net change';
        case 'Summa anläggningstillgångar': return 'Sum fixed assets';
        case 'Summa eget kapital och skulder': return 'Sum equity and total debt';
        case 'Summa intäkter': return 'Total Income';
        case 'Summa kassaflöde från den löpande verksamheten': return 'Total cashflow from operating activities';
        case 'Summa omsättningstillgångar': return 'Sum current assets';
        case 'Summa skulder': return 'Sum debt';
        case 'Summa tillgångar': return 'Total assets';
        case 'Summering': return 'Summary';
        case 'Tecknat men ej inbetalt kapital': return 'Subscribed capital unpaid';
        case 'Tele & post': return 'Telecommunications and postal services';
        case 'Tidplan': return 'Schedule';
        case 'Tillbaka': return 'Return';
        case 'Tillgångar': return 'Assets';
        case 'Tillväxt': return 'Growth';
        case 'Totala tillgångar': return 'Total assets';
        case 'Totalbedömning': return 'Overall ranking';
        case 'Transportmedel': return 'Transport equipment costs';
        case 'UB': return 'CB';
        case 'UB Kassa & Bank': return 'CB Cash & bank';
        case 'Underentreprenörer': return 'Sub-contractors';
        case 'Undre': return 'Lower';
        case 'Undre kvartil': return 'Lower quartile';
        case 'Utfall och analys av året': return 'Outcome and analysis';
        case 'Uttag(-)/Insättning(+) av ägarkapital': return 'Withdrawal(-)/Deposit(+) from owners';
        case 'Vad?': return 'What?';
        case 'Vad behöver ni göra för att nå resultat?': return 'What do you need to do to achieve results?';
        case 'Vad vill ni åstadkomma?': return 'What do you want to achieve?';
        case 'Vad säger era intressenter och vad tänker omvärlden?': return 'What do your stakeholders say and what does the outside world think?';
        case 'Var kommer pengarna ifrån': return 'Where do the money come from';
        case 'Var står ni idag?': return 'Where are you today?';
        case 'Varför?': return 'Why?';
        case 'Varför skall talanger välja er som arbetsgivare?': return 'Why should talents choose you as an employer?';
        case 'Varor & material': return 'Goods and materials';
        case 'Vart tar pengarna vägen?': return 'Where does the money go?';
        case 'Varulager': return 'Inventories';
        case 'Varulager m.m.': return 'Inventories';
        case 'Verksamheter utan ett hållbart perspektiv blir en risk för beställare, leverantörer, långivare och investerare': return 'Operations without a sustainable perspective become a risk for customers, suppliers, lenders and investors';
        case 'Vilka?': return 'Who?';
        case 'Vilka hållbarhetsområden är väsentliga?': return 'Which areas of sustainability are essential?';
        case 'Visualisering av balans- och resultaträkning': return 'Visualization of balance sheet and income statement';
        case 'Vår rådgivning': return 'Our services';
        case 'Väsentlighet': return 'Significance';
        case 'Året hittills': return 'Year review';
        case 'Årets förlust': return 'Net loss';
        case 'Årets kassaflöde': return 'Total cash flow';
        case 'Årets resultat': return 'Net result';
        case 'Årets skatt': return 'Tax';
        case 'Årets vinst': return 'Net profit';
        case 'Årsavslutsmöte': return 'Auditing meeting';
        case 'Årsredovisning:': return 'Financial statement';
        case 'Ägarfrågor': return 'Ownership issues';
        case 'Ägare & finansiärer': return 'Owners & financiers';
        case 'Ägarplanering': return 'Owner planning';
        case 'Är er affärsmodell framtidssäkrad?': return 'Is your business model future-proof?';
        case 'Ökad styrning genom nya lagar, regler och krav på rapportering': return 'Increased governance through new laws, rules and reporting requirements';
        case 'Ökning(-)/Minskning(+) av Anläggningstillgångar': return 'Increase(-)/Decrease(+) Fixed assets';
        case 'Ökning(-)/Minskning(+) av Kortfristiga placeringar': return 'Increase(-)/Decrease(+) Short Investments';
        case 'Ökning(-)/Minskning(+) av Kundfordringar': return 'Increase(-)/Decrease(+) Accounts receivable';
        case 'Ökning(-)/Minskning(+) av Varulager': return 'Increase(-)/Decrease(+) Inventory';
        case 'Ökning(-)/Minskning(+) av Övriga kortfristiga fordringar': return 'Increase(-)/Decrease(+) Other receivables';
        case 'Översikt': return 'Overview';
        case 'Övr. externa kostnader': return 'Other external costs';
        case 'Övre': return 'Upper';
        case 'Övre kvartil': return 'Upper quartile';
        case 'Övriga ext. kostnader': return 'Other external costs';
        case 'Övriga externa kostnader': return 'Other external costs';
        case 'Övriga externa tjänster': return 'Other external services';
        case 'Övriga försäljningskostnader': return 'Other selling expenses';
        case 'Övriga intäkter': return 'Other operating income';
        case 'Övriga kortfristiga fordringar': return 'Other receivables';
        case 'Övriga omsättnings-tillgångar': return 'Other current assets';
        case 'Övriga rörelseintäkter': return 'Other operating income';
        case 'Övriga rörelsekostnader': return 'Other operating costs';
        case 'Övrigt': return 'More';
      }
    }
    // console.warn('Missing translation!');
    // console.warn(`case \'${term}\':\'${term}\',`);
    return term;
  }
}

export default new Translations();
